<clp-toolbar [title]="('financials.revenueList.title' | translate)"></clp-toolbar>

@if (filteredPayments$ | async; as payments) {
  <div class="finance-page px-4 py-4">
    <div class="mx-auto w-full max-w-7xl space-y-4">
      <section class="finance-overview-grid">
        <article class="finance-metric finance-metric-highlight">
          <p class="finance-metric-label">{{ 'financials.revenueList.totalRevenue' | translate }}</p>
          @if (payments.length > 0) {
            <p class="finance-metric-value">{{ total | translocoCurrency: 'symbol' : { minimumFractionDigits: 2 }: currency }}</p>
          } @else {
            <p class="finance-metric-value">-</p>
          }
          <p class="finance-metric-subtitle">{{ 'financials.revenueList.summaryTitle' | translate }}</p>
        </article>

        <article class="finance-metric">
          <p class="finance-metric-label">{{ 'financials.revenueList.transactions' | translate }}</p>
          <p class="finance-metric-value">{{ payments.length }}</p>
          <p class="finance-metric-subtitle">{{ unpaidCount }} {{ 'financials.paymentStatus.unpaid' | translate }}</p>
        </article>

        <article class="finance-metric">
          <p class="finance-metric-label">{{ 'financials.paymentStatus.paid' | translate }}</p>
          <p class="finance-metric-value">{{ paidCount }}</p>
          @if (payments.length > 0) {
            <p class="finance-metric-subtitle">{{ paidAmount | translocoCurrency: 'symbol' : { minimumFractionDigits: 2 }: currency }}</p>
          } @else {
            <p class="finance-metric-subtitle">-</p>
          }
        </article>

        <article class="finance-metric">
          <p class="finance-metric-label">{{ 'financials.revenueList.averageTicket' | translate }}</p>
          @if (payments.length > 0) {
            <p class="finance-metric-value">{{ averageTicket | translocoCurrency: 'symbol' : { minimumFractionDigits: 2 }: currency }}</p>
          } @else {
            <p class="finance-metric-value">-</p>
          }
          <p class="finance-metric-subtitle">{{ 'financials.revenueList.latestPayments' | translate }}</p>
        </article>
      </section>

      <section class="clp-card finance-filters-card">
        <div class="clp-card-body">
          <div class="finance-filters-header">
            <div>
              <h3 class="finance-list-title">{{ 'financials.revenueList.filtersTitle' | translate }}</h3>
            </div>
            <button type="button" class="clp-btn clp-btn-ghost clp-btn-sm" (click)="clearFilters()">
              {{ 'general.clear' | translate }}
            </button>
          </div>

          <form class="finance-filters-grid" [formGroup]="filterForm" novalidate>
            <div>
              <label for="fromDate" class="clp-label">{{ 'financials.revenueList.fromDate' | translate }}</label>
              <p-calendar
                id="fromDate"
                formControlName="fromDate"
                [showIcon]="true"
                styleClass="w-full"
                inputStyleClass="clp-input">
              </p-calendar>
            </div>

            <div>
              <label for="toDate" class="clp-label">{{ 'financials.revenueList.toDate' | translate }}</label>
              <p-calendar
                id="toDate"
                formControlName="toDate"
                [showIcon]="true"
                styleClass="w-full"
                inputStyleClass="clp-input">
              </p-calendar>
            </div>

            <div>
              <label for="courseFilter" class="clp-label">{{ 'financials.revenueList.course' | translate }}</label>
              <select id="courseFilter" class="clp-select" formControlName="course">
                <option value="">{{ 'financials.revenueList.allCourses' | translate }}</option>
                @for (course of courseOptions; track course) {
                  <option [value]="course">{{ course }}</option>
                }
              </select>
            </div>

            <div>
              <label for="userFilter" class="clp-label">{{ 'financials.revenueList.user' | translate }}</label>
              <select id="userFilter" class="clp-select" formControlName="user">
                <option value="">{{ 'financials.revenueList.allUsers' | translate }}</option>
                @for (user of userOptions; track user) {
                  <option [value]="user">{{ user }}</option>
                }
              </select>
            </div>

            <div>
              <label for="statusFilter" class="clp-label">{{ 'financials.revenueList.status' | translate }}</label>
              <select id="statusFilter" class="clp-select" formControlName="status">
                <option value="">{{ 'financials.revenueList.allStatuses' | translate }}</option>
                @for (status of statusOptions; track status) {
                  <option [value]="status">{{ ('financials.paymentStatus.' + status) | translate }}</option>
                }
              </select>
            </div>
          </form>
        </div>
      </section>

      <section class="clp-card finance-list-card">
        <div class="clp-card-body">
          <div class="finance-list-header">
            <div>
              <h3 class="finance-list-title">{{ 'financials.revenueList.latestPayments' | translate }}</h3>
              <p class="finance-list-subtitle">{{ 'financials.revenueList.summaryDescription' | translate }}</p>
            </div>
            <span class="finance-list-count">{{ payments.length }}</span>
          </div>

          @if (payments.length === 0) {
            <div class="finance-empty-state">
              <i class="fa-solid fa-wallet"></i>
              <p>{{ 'financials.revenueList.noRevenue' | translate }}</p>
            </div>
          } @else {
            <div class="finance-table-head">
              <span>{{ 'financials.revenueList.date' | translate }}</span>
              <span>{{ 'financials.revenueList.course' | translate }}</span>
              <span>{{ 'financials.revenueList.user' | translate }}</span>
              <span>{{ 'financials.revenueList.status' | translate }}</span>
              <span class="finance-table-head-amount">{{ 'financials.revenueList.amount' | translate }}</span>
            </div>

            <div class="finance-list-items">
              @for (payment of payments; track payment.billingTransactionId ?? payment.orderId ?? payment.sourceId ?? $index) {
                <clp-billing-thumb [payment]="payment"></clp-billing-thumb>
              }
            </div>
          }
        </div>
      </section>
    </div>
  </div>
}
